module.exports = {"SEARCH_PLACEHOLDER":"กำลังค้นหา...","SEARCH_FILTER_DEFAULT_TEXT":"แคมเปญทั้งหมด"}